import React from 'react';

import FormPwdResetMail from '../forms/FormPwdResetMail.jsx';

import meta from '~/commons/config/meta';

import PageNotFound from '../../../commons/components/PageNotFound.jsx';
import useQuery from '../../../commons/hooks/useQuery';

const t = {
  en: {
    title: 'Reset password email',
  },
  'zh-Hant': {
    title: '傳送重設密碼電郵',
  },
};
const PagePwdResetMail = ({ expired = false }) => {
  const { lg = 'en' } = useQuery();
  if (lg !== 'zh-Hant' && lg !== 'en') {
    return <PageNotFound />;
  }

  meta.set({ title: t[lg].title });

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <FormPwdResetMail expired={expired} />
        </div>
      </div>
    </div>
  );
};

export default PagePwdResetMail;
